export const API_HOST = `https://test.pamyatki.sandbox.wake-app.net/api/backoffice/`;
